import { JsonConverter, JsonCustomConvert } from 'json2typescript';
import { Moment } from 'moment';
import moment from 'moment';

@JsonConverter
export class DateOrderAdapter implements JsonCustomConvert<Moment | undefined> {
    serialize(date: Moment): any | undefined {
        return date ? date.format('YYYY-MM-DD HH:mm:ss') : undefined;
    }

    deserialize(date: any): Moment | undefined {
        if (date && date !== '0001-01-01 00:00:00' && date !== '1900-01-01 00:00:00') {
            return moment(date, 'YYYY-MM-DD HH:mm:ss');
        }

        return undefined;
    }
}
